import React from 'react';

const AnimatedCheckbox = ({
  id,
  checked,
  onChange,
  disabled = false,
  label = null,
  labelClassName = '',
  className = '',
  size = 'md', // 'sm', 'md', 'lg'
  ...props
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={sizeClasses[size]}
        {...props}
      />
      {label && (
        <label
          htmlFor={id}
          className={`text-foreground cursor-pointer ${disabled ? 'cursor-not-allowed opacity-50' : ''} ${labelClassName}`}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default AnimatedCheckbox;

